import { memo } from 'react';
import styled from 'styled-components';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAdd,
  faArrowLeftLong,
  faBank,
  faFileExcel,
  faRefresh,
} from '@fortawesome/free-solid-svg-icons';

const StyledPageHeaderContainer = styled.section`
  background-color: #ffffff;
  border-bottom: 1px solid #ebebeb;
  padding: 15px 25px;
  margin: 0px;
  display: flex;
  column-gap: 20px;
  align-items: center;
  h1 {
    font-size: 30px;
    font-weight: normal;
    color: #000000;
    margin: 0px;
    padding: 0px;
    @media (max-width: 600px) {
      font-size: 18px;
    }
  }
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const StyledPageHeadingContainer = styled.section`
  display: flex;
  column-gap: 10px;
  flex: 1;
`;

const StyledPageHeadingActionsContainer = styled.section`
  display: flex;
  column-gap: 10px;
  @media (max-width: 600px) {
    margin-bottom: 0px;
  }
`;

const StyledBackButtonContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  svg {
    color: #000000;
  }
`;

const StyledHeadingContainer = styled.section`
  flex: 1;
  display: flex;
  align-items: center;
`;

const StyledAddButtonContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    font-size: 14px;
    font-weight: normal;
    color: #ffffff;
    background-color: green;
    padding: 10px 30px;
    border-radius: 10px;
    outline: 0px;
    text-decoration: none;
    &:hover {
      background-color: #0179af;
    }
    @media (max-width: 600px) {
      display: block;
      padding: 10px 15px;
    }
  }
  @media (max-width: 600px) {
    display: block;
    margin-top: 15px;
  }
`;

const StyledReloadButton = styled.button`
  font-size: 14px;
  font-weight: normal;
  color: #ffffff;
  background-color: #03a9f4;
  padding: 10px 30px;
  border-radius: 10px;
  outline: 0px;
  text-decoration: none;
  border: 0px;
  cursor: pointer;
  &:hover {
    background-color: #0179af;
  }
  @media (max-width: 600px) {
    display: block;
    padding: 10px 15px;
  }
`;

const StyledExportButton = styled.button`
  font-size: 14px;
  font-weight: normal;
  color: #ffffff;
  background-color: #673ab7;
  padding: 10px 30px;
  border-radius: 10px;
  outline: 0px;
  text-decoration: none;
  border: 0px;
  cursor: pointer;
  &:hover {
    background-color: #3f1e78;
  }
  @media (max-width: 600px) {
    display: block;
    padding: 10px 15px;
  }
`;

const StyledLoadButton = styled.button`
  font-size: 14px;
  font-weight: normal;
  color: #ffffff;
  background-color: green;
  padding: 10px 30px;
  border-radius: 10px;
  outline: 0px;
  text-decoration: none;
  border: 0px;
  cursor: pointer;
  &:hover {
    background-color: #034903;
  }
  @media (max-width: 600px) {
    display: block;
    padding: 10px 15px;
  }
`;

const PageHeader = memo(
  ({
    title,
    showBackButton = false,
    showAddButton = false,
    addLink = 'add',
    addTitle = 'Add',
    showReloadData = false,
    reloadData = () => { },
    showExportButton = false,
    onClickExport = () => { },
    showLoadButton = false,
    onClickLoad = () => { },
  }) => {
    const navigate = useNavigate();

    const goBack = () => {
      navigate(-1);
    };

    return (
      <StyledPageHeaderContainer>
        <StyledPageHeadingContainer>
          {showBackButton && (
            <StyledBackButtonContainer onClick={goBack} title="Go Back">
              <FontAwesomeIcon icon={faArrowLeftLong} />
            </StyledBackButtonContainer>
          )}
          <StyledHeadingContainer>
            <h1>{title}</h1>
          </StyledHeadingContainer>
        </StyledPageHeadingContainer>
        <StyledPageHeadingActionsContainer>
          {showAddButton && (
            <StyledAddButtonContainer>
              <NavLink to={addLink} title={addTitle}>
                <FontAwesomeIcon icon={faAdd} /> {addTitle}
              </NavLink>
            </StyledAddButtonContainer>
          )}
          {showLoadButton && (
            <StyledAddButtonContainer>
              <StyledLoadButton onClick={onClickLoad} title={'Load'}>
                <FontAwesomeIcon icon={faBank} /> Load
              </StyledLoadButton>
            </StyledAddButtonContainer>
          )}
          {showExportButton && (
            <StyledAddButtonContainer>
              <StyledExportButton onClick={onClickExport} title={'Export'}>
                <FontAwesomeIcon icon={faFileExcel} /> Export
              </StyledExportButton>
            </StyledAddButtonContainer>
          )}
          {showReloadData && (
            <StyledAddButtonContainer>
              <StyledReloadButton onClick={reloadData} title={'Refresh'}>
                <FontAwesomeIcon icon={faRefresh} /> Refresh
              </StyledReloadButton>
            </StyledAddButtonContainer>
          )}
        </StyledPageHeadingActionsContainer>
      </StyledPageHeaderContainer>
    );
  }
);

export default PageHeader;
